import React from 'react';

import styled from 'styled-components';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

import SearchBarItem from './searchBarItem';

const ResponsiveSearchDrawerItemContent = styled.div`
  width: 100%;
`;

interface ResponsiveDrawerInterface {
  icon:
    | React.FunctionComponent<
        React.SVGProps<SVGSVGElement> | CustomIconComponentProps
      >
    | React.ComponentClass<
        React.SVGProps<SVGSVGElement> | CustomIconComponentProps,
        any
      >
    | undefined;

  title: string;
  subTitle: string;
  arrowIcon: boolean;
  onClick:
    | ((event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void)
    | undefined;

  className?: string;
  error?: boolean;
  isFilled?: boolean;
}

const ShopAndFlyResponsiveSearchDrawerItem: React.FC<
  ResponsiveDrawerInterface
> = ({ subTitle, onClick }) => {
  const onKeyPress = (e: any): void => {
    const enterOrSpace =
      e.key === 'Enter' ||
      e.key === ' ' ||
      e.key === 'Spacebar' ||
      e.which === 13 ||
      e.which === 32;
    if (enterOrSpace) {
      e.preventDefault();
      if (onClick) onClick(e);
    }
  };

  return (
    <ResponsiveSearchDrawerItemContent
      onClick={onClick}
      onKeyPress={onKeyPress}
    >
      <SearchBarItem subTitle={subTitle} />
    </ResponsiveSearchDrawerItemContent>
  );
};

export default ShopAndFlyResponsiveSearchDrawerItem;
